/* eslint-disable camelcase */
import VehicleApiResponse, { VehicleInfo } from 'types/Apis/VehicleApiResponse';

export function transformVehicleApiResponse(vehicle: VehicleApiResponse): VehicleInfo {
  const {
    price,
    mileage,
    transmission,
    driveline,
    mpg,
    make,
    model,
    year,
    trim,
    vin,
    tracking_params,
    exterior_color,
    interior_color,
    fuel_type,
    engine_type,
    photo_urls,
    price_formatted,
    body_style,
    door_count,
    remote_sku,
    primary_photo_url,
    listing_id,
    dealer_name,
    zip,
  } = vehicle;

  return {
    price,
    mileage: mileage ?? 0,
    transmission,
    driveline: driveline ?? '',
    mpg: mpg ?? '',
    make,
    model,
    year,
    trim: trim ?? '',
    vin,
    trackingParams: tracking_params,
    exteriorColor: exterior_color,
    interiorColor: interior_color,
    fuelType: fuel_type ?? '',
    engineType: engine_type ?? '',
    photoUrls: photo_urls,
    priceFormatted: price_formatted ?? '',
    bodyStyle: body_style,
    doors: door_count ?? 4,
    stockNumber: remote_sku ?? '',
    primaryPhotoUrl: primary_photo_url,
    listingId: listing_id,
    dealerName: dealer_name,
    zip,
  };
}
